import React from 'react';
import './ZoomControl.scss';

class ZoomControl extends React.Component {
  constructor(props) {
    super(props);

    this._handleZoomOutClicked = this._handleZoomOutClicked.bind(this);
    this._handleZoomInClicked = this._handleZoomInClicked.bind(this);
    this._updateScaleFactor = this._updateScaleFactor.bind(this);
  }

  render() {
    const { scaleFactor } = this.props;

    return (
      <div className="zoom-control">
        <div className="zoom-percentage">{Math.round(scaleFactor * 100)}%</div>
        <div className="zoom-button zoom-out-button" onClick={this._handleZoomOutClicked}>
          &ndash;
        </div>
        <div className="zoom-button zoom-in-button" onClick={this._handleZoomInClicked}>
          +
        </div>
      </div>
    );
  }

  _handleZoomOutClicked() {
    this._updateScaleFactor(-this.props.stepSize);
  }

  _handleZoomInClicked() {
    this._updateScaleFactor(this.props.stepSize);
  }

  _updateScaleFactor(delta) {
    const { scaleFactor, minScaleFactor, maxScaleFactor, onScaleFactorChanged } = this.props;
    let newScaleFactor = scaleFactor + delta;

    if (newScaleFactor > maxScaleFactor) {
      newScaleFactor = maxScaleFactor;
    } else if (newScaleFactor < minScaleFactor) {
      newScaleFactor = minScaleFactor;
    }

    onScaleFactorChanged(newScaleFactor);
  }
}
export default ZoomControl;
